import React from 'react';
import '../../../../incase-domain/components/report/answer/likertScale/reportAnswerLikertScale.scss';
import {QuestionReport} from '../../../../incase-domain/analytics';
import ReportAnswerLikertScale from '../../../../incase-domain/components/report/answer/likertScale/ReportAnswerLikertScale';
import {IElementLikertScale} from '../../../../incase-domain/elements/question/likertScale';

interface DummyLikertScaleReportProps {
    question: IElementLikertScale;
}

function DummyLikertScaleReport({question}: DummyLikertScaleReportProps): JSX.Element | null {
    const dummyQuestionReport: QuestionReport = {
        question: question.question,
        answers: question.scale.map((scale) => ({
            answerText: scale.text,
            percentage: null,
        })),
        likertScaleData: question.questions.map((questionData, i1) => ({
            questionText: questionData.text,
            questionId: questionData.id,
            ...question.scale.reduce((acc, scale, i2) => {
                acc[scale.text] = Math.round((i1 + i2) * 100);
                return acc;
            }, {} as {[key: string]: number}),
        })) as unknown as {[key: string]: number}[],
    } as unknown as QuestionReport;

    return <ReportAnswerLikertScale key={question.id} questionReport={dummyQuestionReport} likertQuestions={question.questions} />;
}
export default DummyLikertScaleReport;
